import { InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Order } from '../Order'

@InputType()
export class GetMyOrderArgs extends ActionArgs {
  _id?: unknown
}

export interface IGetMyOrder extends IAction<Order, GetMyOrderArgs> {}
